/**
 * Alphanumeric characters.
 * @const
 */
const ALPHANUM = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const NUM = "0123456789";

const RandomUtils = {
  /**
   * Generates random alphanumeric id with length of 10.
   *
   * @returns {String} Random string id.
   */
  randomId: function () {
    var random = Math.random().toString(36);
    return random.substring(2, random.length);
  },

  /**
   * Generates random int within the range [min, max].
   *
   * @param {number} min - The minimum value for the generated number.
   * @param {number} max - The maximum value for the generated number.
   * @returns {number} Random int number.
   */
  randomInt: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },

  /**
   * Generates random alphanumeric string.
   *
   * @param {number} length - The size of generated string.
   * @returns {String} Random string.
   */
  randomString: function (length) {
    let ret = "";
    for (let i = 0; i < length; i++) {
      ret += ALPHANUM.charAt(Math.floor(Math.random() * ALPHANUM.length));
    }
    return ret;
  },

  /**
   * Generates random uuid string.
   *
   * @returns {String} Random uuid string.
   */
  randomUuid: function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },

  /**
   * Generate random string of number with length
   *
   * @param {number} length - The size of generated string.
   * @returns {String} Random number string
   */
  randomNumberString: function (length) {
    let ret = "";
    for (let i = 0; i < length; i++) {
      ret += NUM.charAt(Math.floor(Math.random() * NUM.length));
    }
    return ret;
  },
};

export default RandomUtils;
